import PaginationControl from './PaginationControl.ts.vue';
import SimpleTable from './SimpleTable.vue';
import Table from './Table.vue';
import TableBody from './TableBody.vue';
import TableButtonCell from './TableButtonCell.vue';
import TableCell from './TableCell.vue';
import TableExtraHeader from './TableExtraHeader.ts.vue';
import TableHead from './TableHead.vue';
import TableHeadCell from './TableHeadCell.vue';
import TableMessage from './TableMessage.vue';
import TableRow from './TableRow.vue';

export default [
  PaginationControl,
  Table,
  TableBody,
  TableButtonCell,
  TableCell,
  TableExtraHeader,
  TableHead,
  TableHeadCell,
  TableMessage,
  TableRow,
  SimpleTable,
];
